<template>
  <div class="deal_record info">
      <slot/>
    <el-table class="table" ref="multipleTable" :data="doneListData" stripe highlight-current-row size="mini" style="width: 1100px;" height="100%">
      <el-table-column label="销售单号" width="180">
        <template v-slot="scope">
          <span class="link" @click="linkToDetail(scope.row.id)">{{scope.row.order_sn}}<span class="clickImage"></span></span>
        </template>
      </el-table-column>
      <el-table-column prop="out_time" label="成交日期" width="150"></el-table-column>
      <el-table-column prop="count" label="成交件数" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sales_cube" label="成交立方" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sales_amount" label="销售金额" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="outstanding_amount" label="未结金额" width="150" show-overflow-tooltip>
        <template v-slot="scope">
          {{scope.row.outstanding_amount ? scope.row.outstanding_amount : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column prop="invoice_not" label="未开票金额" show-overflow-tooltip>
        <template v-slot="scope">
          {{scope.row.invoice_not ? scope.row.invoice_not : '0.00'}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
        <pagination v-if="refresh" ref="pagination" :lastpages.sync="donePages.last_page" :currentpages.sync="donePages.current_page" :all.sync="donePages.total" :pagesizes.sync="donePages.per_page" @getPage="getPage"></pagination>
    </div>
    <!-- 合计 -->
    <div class="total">
        <span>合计</span><span>成交次数：{{total_all.total_count}}次</span><span>成交立方：{{total_all.total_sales_cube ? total_all.total_sales_cube : 0}}m³</span><span>销售金额：￥{{total_all.total_sales_amount}}</span><span>未结金额：￥{{total_all.total_outstanding_amount}}</span><span>未开票金额：￥{{total_all.total_invoice_not}}</span>
    </div>

      <!--销售单弹窗-->
      <sale-bill-base ref="saleBillBase" :dialog="dialogVisible" @hide="dialogVisible=false"
                      :dt="orderType" :form-data="detailInfo" :scene="'finance.order.column'">
          <div class="editBtnList clearfix">
              <div style="float:left;">
                  <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                      <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                          {{list.fee_name+':  ￥'+list.amount}}
                      </div>
                  </div>
              </div>
          </div>
      </sale-bill-base>

  </div>
</template>

<script>
    import pagination from '../../../components/pagination';
    import saleBillBase from '../../../components/saleBillBase';
export default {
    components: {
        pagination,
        saleBillBase
    },
    props: {
        doneListData: {
            type: Array,
            default(){
                return []
            }
        },
        donePages: {
            type: Object,
            default(){
                return {
                    last_page: 0,
                    total: 0,
                    current_page: 1,
                    per_page: 20
                }
            }
        },
        total_all: {
            type: Object,
            default(){
                return {
                    total_count: 0,
                    total_out_cube: 0,
                    total_already_amount: 0,
                    total_outstanding_amount: 0,
                    total_invoice_not: 0
                }
            }
        }
    },
    data(){
        return {
            dialogVisible:false,
            newFee: [],
            detailInfo: {},
            orderType: 3,

            module:localStorage.dw_erp_power_code,
            last_page: 1,
            current_page: 1,
            total: 100,
            page: 1,
            per_page: 10,
            dialogVisibleRelation:false,

            orderDetailVisible: false,
            enableConfig:localStorage.dw_erp_enable_config,
            refresh: true,
            filterDialogVisible: false,
            filter:[],
        }
    },
    methods: {

        getPage(obj){
            this.$emit('dealPageChangeEvent', obj)
        },
        linkToDetail(id){
            this.postFuncLoading("/erp/finance.order", {id: id}, res => {
                this.orderType = 3;
                let resD = res.data.data;
                this.newFee = resD.fee_list;
                this.detailInfo = resD;
                this.detailInfo.saleOrderIsEdit = false;
                this.dialogVisible = true;
            }, error => {
                this.tip(error.data.message, "warning")
            });
        },
    },
    mounted(){
    },
    watch: {
        donePages(){
            //强制刷新组件
            this.refresh = false;
            this.$nextTick(()=>{
                this.refresh = true;
            })
        }  ,
        "dialogVisible":function(val){
            if(!val){
                this.detailInfo = {};
                this.newFee = [];
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.deal_record{
    display: flex;
    flex-direction: column;
    height: 100%;
    .table{
        flex: 1;
        .link{
            color: rgb(255, 0, 0);
            text-decoration: underline;
            cursor: pointer
        }
        .clickImage{
            position: relative;
            top: 3px;
            left: 4px;
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url(../../../../public/icon/details.png) transparent no-repeat center;
            background-size: contain;
        }
    }
    .pag{
        width: 1100px;
        text-align: center;
       
    }
    .total{
        display: flex;
        margin-top: 10px;
        background-color: #f2f2f2;
        padding: 10px;
        font-size: 14px;
        padding-left: 40px;
        span{
            margin-right: 20px;
        }
    }
}

</style>